module.exports = __webpack_public_path__ + "static/GT-Walsheim-Bold-2159cae9adc7a75e1b1b228d7151948b.woff2";